
export default function LogoWall () {
  const logoWalls = document.querySelectorAll('.mtt-logo-wall')
  if (logoWalls.length > 0) {
    logoWalls.forEach(function (logoWall) {
      const loadMoreButton = logoWall.querySelector('.mtt-logo-wall__load-more-button')
      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
          logoWall.classList.add('mtt-logo-wall--show-all')

          loadMoreButton.parentElement.remove()
        })
      }
    })
  }
}
